import React from "react";
import { AppHeader } from "../../../components/layout/AppHeader";
import { useLandingScrollToSection } from "./marketing/useLandingScrollToSection";
import {
  AppDownloadSection,
  CTASection,
  DifferentFromFsmSection,
  LandingFooter,
  LandingHeroSection,
  PricingSection,
  ProductsSection,
  TestimonialsSection,
  TradesSection,
  TrustFeaturesBar,
  WhyToolKitSection,
} from "./landing";
import type {
  AppStoreLinks,
  RouteMap,
  TradeContent,
  UserDisplay,
} from "../types";

type LandingPageProps = {
  loggedIn: boolean;
  hasBusiness: boolean;
  hasOrganization?: boolean;
  canAccessBackend?: boolean;
  routes: RouteMap;
  csrfToken: string;
  page: string;
  userDisplay?: UserDisplay | null;
  trades?: TradeContent[];
  appStore?: AppStoreLinks | null;
};

export const LandingPage: React.FC<LandingPageProps> = ({
  loggedIn,
  hasBusiness,
  hasOrganization,
  canAccessBackend,
  routes,
  csrfToken,
  page,
  userDisplay,
  trades,
  appStore,
}) => {
  const scrollToSection = useLandingScrollToSection();

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <AppHeader
        variant="landing"
        loggedIn={loggedIn}
        hasBusiness={hasBusiness}
        hasOrganization={hasOrganization}
        canAccessBackend={canAccessBackend}
        routes={routes}
        csrfToken={csrfToken}
        page={page}
        userDisplay={userDisplay}
        scrollToSection={scrollToSection}
      />
      <LandingHeroSection routes={routes} scrollToSection={scrollToSection} />
      <TrustFeaturesBar />
      <ProductsSection />
      <AppDownloadSection routes={routes} appStore={appStore} />
      <TradesSection trades={trades} />
      <WhyToolKitSection scrollToSection={scrollToSection} />
      <DifferentFromFsmSection />
      <PricingSection routes={routes} />
      <TestimonialsSection />
      <CTASection routes={routes} />
      <LandingFooter
        loggedIn={loggedIn}
        hasBusiness={hasBusiness}
        hasOrganization={hasOrganization}
        canAccessBackend={canAccessBackend}
        routes={routes}
        scrollToSection={scrollToSection}
      />
    </div>
  );
};
